/**
 * Is this aircraft flying or on the ground? (#807)
 *
 * Extracted from AffLayerProvider so it can be exercised directly. It decides
 * which icon a marker gets, and #804's trailing tail is drawn only for aircraft
 * this reports as flying, so it needs to be right rather than merely plausible.
 *
 * The gate previously tested `feature.properties.aspeed`, a property produced
 * nowhere in the codebase. `undefined == 0` is false, so the speed condition
 * never fired and a stationary aircraft with a current fix was drawn as flying.
 * The published property is `speed` (`affRouter.ts`), in metres per second.
 */

/** Not reporting for this long means on the ground, whatever the last fix said. */
export const AIRCRAFT_LANDED_AFTER_MINUTES = 30;

type AircraftProps = Record<string, any> | null | undefined;

export const aircraftStatus = (props: AircraftProps): 'flying' | 'landed' => {
  if (!props) return 'landed';

  // A reported zero means stationary. An absent speed is not zero — it is no
  // measurement, and must not by itself put an aircraft on the ground.
  if (props.speed === 0) return 'landed';

  if (props.stale === true) return 'landed';
  if (props.fresh === false) return 'landed';
  if (typeof props.recordAgeMins === 'number' && props.recordAgeMins >= AIRCRAFT_LANDED_AFTER_MINUTES) {
    return 'landed';
  }

  // recordAgeMins is the collector's own reckoning; where it is absent, fall
  // back to the observation time. The live layer supplies epoch milliseconds,
  // sometimes as a string.
  const observed = Number(props.positionTimestamp);
  if (Number.isFinite(observed)) {
    const ageMinutes = Math.floor((Date.now() - observed) / 60_000);
    if (ageMinutes >= AIRCRAFT_LANDED_AFTER_MINUTES) return 'landed';
  }

  return 'flying';
};
